import { computed } from 'vue'
import { useQuery } from '@pinia/colada'
import { InjectionTypes } from '@/constants/InjectionTypes'
import { useInjectOrThrow } from '@/shared/useInjectOrThrow'

export function useGetApplicationList() {
  const useCase = useInjectOrThrow(InjectionTypes.GetApplicationListUseCase)

  const query = useQuery({
    key: ['applications'],
    query: () => useCase.execute(),
  })

  return {
    applications: computed(() => query.data.value ?? []),
    loading: query.isLoading,
  }
}
